import forEach from './foreach.js';
var isEnumerable = Object.prototype.propertyIsEnumerable;
// Object.assign, which IE 11 lacks; symbol keys are copied where the browser has them
var assign = function assign(target) {
  var _arguments = arguments;
  var _loop = function _loop() {
    if (_arguments[i] !== null && _arguments[i] !== undefined) {
      // a primitive is read as an object: IE 11's Object.keys throws on it
      var source = Object(_arguments[i]);
      forEach(Object.keys(source), function (key) {
        target[key] = source[key];
      });
      if (Object.getOwnPropertySymbols) {
        forEach(Object.getOwnPropertySymbols(source), function (symbol) {
          if (isEnumerable.call(source, symbol)) target[symbol] = source[symbol];
        });
      }
    }
  };
  for (var i = 1; i < arguments.length; i++) {
    _loop();
  }
  return target;
};
export default assign;